<template>
    <div class="safe-data">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    components: {
        
    },
    data () {
        return {
            
        }
    },
    methods: {
        
    },
    mounted() {
        
    }
}
</script>

<style lang="scss" scoped>
    .safe-data{
        width: 100%; height: 100%; padding: 16px; overflow: hidden;
    }
</style>


// WEBPACK FOOTER //
// src/components/SafeData.vue